import { Modifier } from "@dnd-kit/abstract"
import type { DragOperation, Plugins } from "@dnd-kit/abstract"
import { Feedback } from "@dnd-kit/dom"
import type { DragDropManager } from "@dnd-kit/dom"

export class RestrictToVerticalAxis extends Modifier {
  apply(operation: DragOperation) {
    return { x: 0, y: operation.transform.y }
  }
}

const noDropAnimation = Feedback.configure({ dropAnimation: null })

export const disableDropAnimation = (defaults: Plugins<DragDropManager>) =>
  defaults.map(p => (p === Feedback ? noDropAnimation : p))
